const REVIEW_CARD_SELECTOR = '[data-rv3] .carouselPre > .itemsC';

function improveReviewControls(root = document) {
  if (!(root instanceof Document || root instanceof Element)) return;

  const previousButtons = root.querySelectorAll('[data-rv3] :is(.prev, .prevBtn, [class*="prev"])');
  const nextButtons = root.querySelectorAll('[data-rv3] :is(.next, .nextBtn, [class*="next"])');

  previousButtons.forEach((button) => {
    if (button instanceof HTMLElement && !button.getAttribute('aria-label')) {
      button.setAttribute('aria-label', 'Mostrar reseña anterior');
    }
  });

  nextButtons.forEach((button) => {
    if (button instanceof HTMLElement && !button.getAttribute('aria-label')) {
      button.setAttribute('aria-label', 'Mostrar reseña siguiente');
    }
  });
}

function getBackgroundImageUrl(element) {
  if (!(element instanceof HTMLElement)) return '';

  const backgroundImage = element.style.backgroundImage || window.getComputedStyle(element).backgroundImage;
  const match = backgroundImage.match(/^url\(["']?(.*?)["']?\)$/);

  return match?.[1] || '';
}

function validateReviewPhoto(card) {
  if (!(card instanceof HTMLElement) || card.dataset.davinaPhotoState) return;

  card.dataset.davinaPhotoState = 'pending';

  const imageUrl = getBackgroundImageUrl(card.querySelector('.bgImg'));
  if (!imageUrl) {
    card.dataset.davinaPhotoState = 'missing';
    return;
  }

  const image = new Image();
  image.onload = () => {
    card.dataset.davinaPhotoState = image.naturalWidth > 1 && image.naturalHeight > 1 ? 'ready' : 'missing';
  };
  image.onerror = () => {
    card.dataset.davinaPhotoState = 'missing';
  };
  image.src = imageUrl;
}

function validateReviewPhotos(root = document) {
  if (!(root instanceof Document || root instanceof Element)) return;

  if (root instanceof Element && root.matches(REVIEW_CARD_SELECTOR)) {
    validateReviewPhoto(root);
  }

  root.querySelectorAll(REVIEW_CARD_SELECTOR).forEach(validateReviewPhoto);
}

validateReviewPhotos();
improveReviewControls();

const reviewObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node instanceof Element) validateReviewPhotos(node);
      if (node instanceof Element) improveReviewControls(node);
    }
  }
});

reviewObserver.observe(document.documentElement, { childList: true, subtree: true });

document.addEventListener('shopify:section:load', (event) => {
  validateReviewPhotos(event.target);
  improveReviewControls(event.target);
});
